import { render, staticRenderFns } from "./receptVirtualGroupBlock.vue?vue&type=template&id=185e9b14&"
import script from "./receptVirtualGroupBlock.vue?vue&type=script&lang=js&"
export * from "./receptVirtualGroupBlock.vue?vue&type=script&lang=js&"
import style0 from "./receptVirtualGroupBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports